module.exports = __webpack_public_path__ + "static/media/cover-mobile.10684cbb.jpg";